(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bp-bundle-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bp-bundle-picker')) {
    customElements.define('bp-bundle-picker', class extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        this.controller?.abort();
        this.controller = new AbortController();
        this.form?.addEventListener('change', event => {
          if (this.contains(event.target)) {
            const quantity = this.form.querySelector('input[name="quantity"]');
            if (quantity) {
              quantity.value = event.target.value;
              quantity.dispatchEvent(new Event('change', { bubbles:true }));
            }
          }
          this.sync();
        }, { signal:this.controller.signal });
        this.hidden = false;
        this.sync();
      }
      disconnectedCallback() { this.controller?.abort(); }
      setVariant(variant) {
        this.dataset.price = String(variant?.price || 0);
        this.dataset.available = String(Boolean(variant?.available));
        this.sync();
      }
      sync() {
        const quantity = this.form?.querySelector('input[name="quantity"]');
        const price = Number(this.dataset.price);
        const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style:'currency', currency:this.dataset.currency });
        this.querySelectorAll('.bp-bundle-option').forEach(option => {
          const radio = option.querySelector('input');
          const count = Number(radio.value);
          const percent = Number(radio.dataset.percent);
          const original = price * count;
          const saving = Math.floor(original * percent / 100);
          option.querySelector('[data-total]').textContent = money.format((original - saving) / 100);
          option.querySelector('[data-original]').textContent = money.format(original / 100);
          const savingLabel = option.querySelector('[data-save]');
          if (savingLabel) savingLabel.textContent = this.dataset.saveText ? this.dataset.saveText.replace('[amount]', money.format(saving / 100)) : `You save ${money.format(saving / 100)}`;
          if (quantity) radio.checked = Number(quantity.value) === count;
          radio.disabled = this.dataset.available !== 'true' || Boolean(quantity?.max && count > Number(quantity.max)) || count < Number(quantity?.min || 1);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
